import {combineReducers} from "redux";
import result from "./result";
import draw from "./draw";
const resultVn1Reducer = combineReducers({
    result, draw
});

export default resultVn1Reducer;
